export enum HTTP_HEADER {
  'Accept-Language' = 'Accept-Language',
  'X-CSRF-TOKEN' = 'X-CSRF-TOKEN',
}
